module.exports = __webpack_public_path__ + "img/logout.d2695f1e.svg";